import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateOpportunityLostReasonRequest extends BaseUpdateRequest {
    name = '';
}
